export const stepList = {
    office: 1,
    team: 2,
    staff: 3,
    workpattern: 4,
    assignment: 5,
    workCount: 6,
    shiftPattern: 7,
    combination: 8,
    avoidPattern: 9,
    autoCreate: 10,
};

